module.exports = __webpack_public_path__ + "assets/icons/calendar-check-3245.svg";